// How a person is named in words MeeMail writes ("Sam replied since you scheduled this") and in
// snippets ({first_name}): from a display name as mail carries it. Pure; no runtime deps.

/** A display name tidied: quotes off, "Lee, Sam" read as "Sam Lee", spaces collapsed. */
export function displayName(name: string | null | undefined): string {
  const flat = (name ?? "")
    .replace(/^["'\s]+|["'\s]+$/g, "")
    .replace(/\s+/g, " ")
    .trim();
  // A display name that is just the address (or holds one) is not a name.
  if (!flat || flat.includes("@")) return "";
  const comma = /^([^,]+),\s*([^,]+)$/.exec(flat);
  return comma ? `${comma[2]!.trim()} ${comma[1]!.trim()}` : flat;
}

/** The first word of a display name ("Sam" for "Sam Lee" or "Lee, Sam"); "" when there is none. */
export function firstNameOf(name: string | null | undefined): string {
  return displayName(name).split(" ")[0] ?? "";
}
